/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-06-30T17:06:33.74
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	saveFinancialTransfer,
	getFinancialTransferCreateInit,
	getFinancialTransferEditInit,
	getFinancialTransferView,
	deleteFinancialTransfer
} from '@api/financial/FinancialTransfer';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},
	actions: {
		getFinancialTransferCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getFinancialTransferCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getFinancialTransferEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getFinancialTransferEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveFinancialTransfer({}, FinancialTransfer) {
			return new Promise((resolve, reject) => {
				saveFinancialTransfer(FinancialTransfer)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		getFinancialTransferView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getFinancialTransferView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		deleteFinancialTransfer({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteFinancialTransfer({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
